var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2001 2.58358C15.086 2.58358 10.9353 6.78365 10.9353 11.9708C10.9353 17.158 15.086 21.358 20.2001 21.358C21.8933 21.358 23.4769 20.899 24.8404 20.0978C25.4507 19.7392 26.233 19.9484 26.5879 20.5652C26.9427 21.182 26.7356 21.9726 26.1254 22.3313C24.3823 23.3555 22.3569 23.9416 20.2001 23.9416C13.6687 23.9416 8.37891 18.5794 8.37891 11.9708C8.37891 5.36225 13.6687 0 20.2001 0C26.7314 0 32.0212 5.36225 32.0212 11.9708C32.0212 12.6842 31.449 13.2626 30.743 13.2626C30.0371 13.2626 29.4648 12.6842 29.4648 11.9708C29.4648 6.78365 25.3142 2.58358 20.2001 2.58358Z",
    fill: "#F59D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0542 17.0631C35.8895 17.5945 35.4033 17.9561 34.8534 17.9561H26.3977C25.7025 17.9561 25.139 17.3852 25.139 16.681C25.139 15.9768 25.7025 15.406 26.3977 15.406H33.8978C34.1561 14.3294 34.2932 13.2039 34.2932 12.0444C34.2932 8.85073 33.2524 5.90693 31.4952 3.53709C31.0777 2.97404 31.1898 2.17476 31.7456 1.75184C32.3015 1.32892 33.0905 1.44251 33.508 2.00556C35.5814 4.80184 36.8105 8.27958 36.8105 12.0444C36.8105 13.7909 36.5459 15.4772 36.0542 17.0631Z",
    fill: "#F59D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4087 20.992C16.6079 21.6818 16.2077 22.4017 15.5146 22.6001C8.06424 24.7321 2.61139 31.5815 2.61139 39.7006C2.61139 40.4184 2.02681 41.0002 1.3057 41.0002C0.58458 41.0002 0 40.4184 0 39.7006C0 30.3953 6.25026 22.5468 14.793 20.1022C15.4861 19.9039 16.2094 20.3023 16.4087 20.992Z",
    fill: "#F59D0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.188 20.992C24.996 21.6818 25.3817 22.4017 26.0495 22.6001C33.229 24.7321 38.4836 31.5815 38.4836 39.7006C38.4836 40.4184 39.0469 41.0002 39.7418 41.0002C40.4367 41.0002 41 40.4184 41 39.7006C41 30.3953 34.977 22.5468 26.7449 20.1022C26.0771 19.9039 25.38 20.3023 25.188 20.992Z",
    fill: "#F59D0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6426 16.7589C23.6426 15.4366 24.6977 14.3647 25.9993 14.3647H27.5705C28.8721 14.3647 29.9272 15.4366 29.9272 16.7589C29.9272 18.0812 28.8721 19.1531 27.5705 19.1531H25.9993C24.6977 19.1531 23.6426 18.0812 23.6426 16.7589Z",
    fill: "#F59D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/Operator.376f4d1c6c97a3fd56d9d8f984dfc318.svg";
export { ForwardRef as ReactComponent };